export const marketRegions = [
    {
        value: "13-18 - Seattle Engineering",
        label: "13-18 - Seattle Engineering",
    },
    {
        value: "13-28 - Portland Engineering",
        label: "13-28 - Portland Engineering",
    },
    {
        value: "13-48 - Arizona Engineering",
        label: "13-48 - Arizona Engineering",
    },
    {
        value: "15-01 - Reno",
        label: "15-01 - Reno",
    },
    {
        value: "15-05 - Tukwila",
        label: "15-05 - Tukwila",
    },
    {
        value: "15-06 - Tacoma",
        label: "15-06 - Tacoma",
    },
    {
        value: "15-07 - Seattle",
        label: "15-07 - Seattle",
    },
    {
        value: "15-08 - Portland",
        label: "15-08 - Portland",
    },
    {
        value: "15-09 - Bellevue",
        label: "15-09 - Bellevue",
    },
    {
        value: "15-10 - Phoenix",
        label: "15-10 - Phoenix",
    },
    {
        value: "15-11 - Boise",
        label: "15-11 - Boise",
    },
    {
        value: "23-68 - Bay Area Engineering",
        label: "23-68 - Bay Area Engineering",
    },
    {
        value: "23-69 - Sacramento Engineering",
        label: "23-69 - Sacramento Engineering",
    },
    {
        value: "23-78 - San Diego Engineering",
        label: "23-78 - San Diego Engineering",
    },
    {
        value: "23-88 - Orange County Engineering",
        label: "23-88 - Orange County Engineering",
    },
    {
        value: "23-98 - LA Engineering",
        label: "23-98 - LA Engineering",
    },
    {
        value: "25-01 - NorCal",
        label: "25-01 - NorCal",
    },
    {
        value: "25-02 - San Diego",
        label: "25-02 - San Diego",
    },
    {
        value: "25-03 - Irvine",
        label: "25-03 - Irvine",
    },
    {
        value: "25-11 - Sacramento",
        label: "25-11 - Sacramento",
    },
    {
        value: "25-12 - Pasadena",
        label: "25-12 - Pasadena",
    },
    {
        value: "25-13 - El Segundo",
        label: "25-13 - El Segundo",
    },
    {
        value: "25-14 - ARBA/Century City",
        label: "25-14 - ARBA/Century City",
    },
    {
        value: "25-21 - San Francisco Region",
        label: "25-21 - San Francisco Region",
    },
    {
        value: "25-23 - San Jose Region",
        label: "25-23 - San Jose Region",
    },
    {
        value: "25-24 - Pleasanton Region",
        label: "25-24 - Pleasanton Region",
    },
];
